const { sameWithMultiPath } = require('../utils');

module.exports = borders => sameWithMultiPath(borders, ['stroke.dash.type', 'assignedStyles.stroke.dash.type'], 'solid');
